module.exports = __webpack_public_path__ + "img/ingresos_netos.8e9958de.png";